// Please do not change string values. They were introduced by FM and are used for analytics ever since, we want to have continuity in naming.

export const searchHereGTMEvent = () => {
    if ((window as any).dataLayer) {
        return (window as any).dataLayer.push({event: "automap_repeat"});
    }
    return null;
};
